import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import {
    setLeadApproveSuccess,
    setLeadApproveFailure,
} from '../actions/set_lead_approve.actions';
import { SET_LEAD_APPROVE } from '../constants/set_lead_approve.constants';
import { setLeadApproveReport } from '../../requests/set_lead_approve_request';


function* setLeadApproveRequest({ params }) {
    const approveResult = yield call(setLeadApproveReport, params);

    if (approveResult.result) {
        yield put(setLeadApproveSuccess(approveResult.options));
        yield put({ type: 'LEAD_APPROVAL_GET_LEADS', params: {} });
    } else {
        yield put(setLeadApproveFailure(approveResult.error));
        message.error(approveResult.error.message);
    }
}

export default function* setLeadApproveSaga() {
    yield takeEvery(SET_LEAD_APPROVE, setLeadApproveRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/sagas/set_lead_approve.saga.js